import { getMaster } from "utils/api";

export const queryList = async (params) => {
  return await getMaster("/refund-list", {
    sort: "created,desc",
    ...params,
  });
};
